import { makeAction, makeReducer } from '@finn-no/redux-actions';
import type { MonthPickerMonth, PrepackageSearchState } from '../types';

export const toggleMonth = (months: MonthPickerMonth[], month: number, year: number): MonthPickerMonth[] => {
    const copy = [...months];
    const index = copy.findIndex((e) => e.month === month && e.year === year);
    if (index >= 0) {
        copy.splice(index, 1);
    } else {
        copy.push({ month, year });
    }
    return copy;
};

const actions = {
    allFieldsChanged: makeAction<PrepackageSearchState>('PREPACKAGE/ALL_FIELDS_CHANGED', (state, { payload }) => ({
        ...state,
        ...payload,
    })),
    setSearchType: makeAction<PrepackageSearchState>('PREPACKAGE/SET_SEARCH_TYPE', (state, { payload: searchType }) => ({
        ...state,
        searchType: searchType || 'fixed',
    })),
    setOriginAirport: makeAction<PrepackageSearchState>('PREPACKAGE/SET_ORIGIN_AIRPORT', (state, { payload: originAirport }) => ({
        ...state,
        originAirport: originAirport || '',
    })),
    setRawDestination: makeAction<PrepackageSearchState>('PREPACKAGE/SET_RAW_DESTINATION', (state, { payload }) => ({
        ...state,
        destination: payload,
        destinationCity: undefined,
        destinationCountry: undefined,
        boundingBox: undefined,
    })),
    setDestination: makeAction<PrepackageSearchState>('PREPACKAGE/SET_DESTINATION', (state, { payload: destination }) => ({
        ...state,
        destination: destination?.text ?? '',
        destinationCity: destination?.city ?? undefined,
        destinationCountry: destination?.country ?? undefined,
        isCountry: destination?.isCountry ?? undefined,
        boundingBox: destination
            ? `${destination.bounds.southwest_lat},${destination.bounds.southwest_lng},${destination.bounds.northeast_lat},${destination.bounds.northeast_lng}`
            : undefined,
    })),
    clearDestination: makeAction<PrepackageSearchState>('PREPACKAGE/CLEAR_DESTINATION', (state) => ({
        ...state,
        destination: '',
        destinationCity: undefined,
        destinationCountry: undefined,
        boundingBox: undefined,
    })),
    setDates: makeAction<PrepackageSearchState>('PREPACKAGE/SET_DATES', (state, { payload: newDates }) => ({
        ...state,
        departureDate: newDates.startDate ?? null,
        returnDate: newDates.endDate ?? null,
    })),
    setFlexibleDeparture: makeAction<PrepackageSearchState>(
        'PREPACKAGE/SET_FLEXIBLE_DEPARTURE',
        (state, { payload: flexibleDeparture }) => ({
            ...state,
            flexibleDeparture: Number.parseInt(flexibleDeparture) || 0,
        }),
    ),
    toggleTravelMonth: makeAction<PrepackageSearchState>('PREPACKAGE/TOGGLE_TRAVEL_MONTH', (state, { payload: month }) => ({
        ...state,
        travelMonths: toggleMonth(state.travelMonths, month.month, month.year),
    })),
    resetTravelMonths: makeAction<PrepackageSearchState>('PREPACKAGE/RESET_TRAVEL_MONTHS', (state) => ({
        ...state,
        travelMonths: [],
    })),
    setDuration: makeAction<PrepackageSearchState>('PREPACKAGE/SET_DURATION', (state, { payload: duration }) => ({
        ...state,
        duration: {
            from: duration.from || 0,
            to: duration.to || 35,
        },
    })),
    setPaxCombination: makeAction<PrepackageSearchState>('PREPACKAGE/SET_PAX_COMBINATION', (state, action) => ({
        ...state,
        numberOfAdults: action.payload.numberOfAdults,
        agesOfChildren: action.payload.agesOfChildren,
    })),
    setTotalOffers: makeAction<PrepackageSearchState>('PREPACKAGE/SET_TOTAL_OFFERS', (state, { payload: total }) => ({
        ...state,
        totalOffers: total,
    })),
    showCalendar: makeAction<PrepackageSearchState>('CALENDAR/SHOW_CALENDAR', (state, { payload: { calendarId } }) => ({
        ...state,
        calendar: calendarId,
    })),
};

export default actions;
export const reducer = makeReducer<PrepackageSearchState>(actions);
